import clsx from 'clsx';
import type { CameraStatus } from '@api/types';

interface Props {
  status: CameraStatus;
}

export function StatusPill({ status }: Props): JSX.Element {
  const isActive = status === 'active';
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium',
        isActive
          ? 'bg-success/15 text-success'
          : 'bg-muted/15 text-muted',
      )}
    >
      <span
        className={clsx(
          'h-1.5 w-1.5 rounded-full',
          isActive ? 'bg-success animate-pulse' : 'bg-muted',
        )}
      />
      {isActive ? 'Online' : 'Offline'}
    </span>
  );
}
